// emailform.js
import React, { useState } from "react";
import axios from "axios";

const EmailForm = () => {
    const [emailData, setEmailData] = useState({
        to: "",
        subject: "",
        body: "",
    });
    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEmailData({ ...emailData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post("http://127.0.0.1:8000/send-email/", emailData);
            setStatus(response.data.message);
        } catch (error) {
            setStatus(error.response ? error.response.data.detail : "Error sending email");
        }
    };

    return (
        <div>
            <h2>Send Email</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>To:</label>
                    <input type="email" name="to" value={emailData.to} onChange={handleChange} required />
                </div>
                <div>
                    <label>Subject:</label>
                    <input type="text" name="subject" value={emailData.subject} onChange={handleChange} required />
                </div>
                <div>
                    <label>Body:</label>
                    <textarea name="body" value={emailData.body} onChange={handleChange} required />
                </div>
                <button type="submit">Send</button>
            </form>
            {status && <p>{status}</p>}
        </div>
    );
};

export default EmailForm;
